/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discount_Type_Form_Discount_TypeInputs */

const en_admin_discount_type_form_discount_type = /** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount Type`)
};

const de_admin_discount_type_form_discount_type = /** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt-Typ`)
};

const es_admin_discount_type_form_discount_type = /** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de descuento`)
};

const fr_admin_discount_type_form_discount_type = /** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de réduction`)
};

const nl_admin_discount_type_form_discount_type = /** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kortingstype`)
};

/** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */
const it_admin_discount_type_form_discount_type = en_admin_discount_type_form_discount_type;

/** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */
const pt_br2_admin_discount_type_form_discount_type = en_admin_discount_type_form_discount_type;

/** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */
const pl_admin_discount_type_form_discount_type = en_admin_discount_type_form_discount_type;

/** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */
const hu_admin_discount_type_form_discount_type = en_admin_discount_type_form_discount_type;

/** @type {(inputs: Admin_Discount_Type_Form_Discount_TypeInputs) => LocalizedString} */
const ro_admin_discount_type_form_discount_type = en_admin_discount_type_form_discount_type;

/**
* | output |
* | --- |
* | "Discount Type" |
*
* @param {Admin_Discount_Type_Form_Discount_TypeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discount_type_form_discount_type = /** @type {((inputs?: Admin_Discount_Type_Form_Discount_TypeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discount_Type_Form_Discount_TypeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discount_type_form_discount_type(inputs)
	if (locale === "de") return de_admin_discount_type_form_discount_type(inputs)
	if (locale === "es") return es_admin_discount_type_form_discount_type(inputs)
	if (locale === "fr") return fr_admin_discount_type_form_discount_type(inputs)
	if (locale === "nl") return nl_admin_discount_type_form_discount_type(inputs)
	if (locale === "it") return it_admin_discount_type_form_discount_type(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discount_type_form_discount_type(inputs)
	if (locale === "pl") return pl_admin_discount_type_form_discount_type(inputs)
	if (locale === "hu") return hu_admin_discount_type_form_discount_type(inputs)
	return ro_admin_discount_type_form_discount_type(inputs)
});
export { admin_discount_type_form_discount_type as "admin.discount_type_form.discount_type" }